import React, { useEffect, useState, useRef } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { apiGet } from '../api/client';
import type { TwoFactorStatusResponse } from '../types/api';
import LoadingSpinner from '../components/LoadingSpinner';

export default function Require2FA() {
  const [checking, setChecking] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    (async () => {
      try {
        const status = await apiGet<TwoFactorStatusResponse>('/api/auth/2fa/status');
        setEnabled(status.isEnabled);
      } catch {
        // If check fails, assume not enabled — will redirect to setup
        setEnabled(false);
      } finally {
        setChecking(false);
      }
    })();
  }, []);

  if (checking) {
    return <LoadingSpinner fullPage />;
  }

  if (!enabled) {
    return <Navigate to="/setup-2fa" replace />;
  }

  return <Outlet />;
}
